import { Directive, ElementRef, HostListener } from '@angular/core';
import { ConfigProvider } from '../../providers/config/config';
import { ScreenPage } from '../../pages/screen/screen';
import { NavController } from 'ionic-angular';
import { AppState } from '../../config/state';

/**
 * Generated class for the NavScreenDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[nav-screen]' // Attribute selector
})
export class NavScreenDirective {
  private href: string;
  constructor(el: ElementRef, public config: ConfigProvider, private navCtrl: NavController, private state: AppState) {
    this.href = el.nativeElement.getAttribute('href');
  }
  @HostListener('click', ['$event']) onClick($event) {
    this.config.load(this.state.appId).then(cfg => {
      const screen = cfg.screens.find(screen => screen.name == this.href);
      if (screen) {
        if (screen.title) document.title = screen.title;
        this.navCtrl.push(ScreenPage, { screenData: screen });
      }
    });
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/directives/nav-screen/nav-screen.ts